"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/**
 * Events constants for player
 * @typedef {{
 * play: string,
 * waiting: string,
 * positionChanged: string,
 * mediaEnded: string,
 * buffer: string,
 * seeked: string,
 * error: string
 * }} StreamEvents
 */
var streamEvents = {
  buffer: 'buffer',
  positionChanged: 'positionChanged',
  waiting: 'waiting',
  play: 'play',
  error: 'error',
  mediaEnded: 'mediaEnded',
  seeked: 'seeked',
  meta: 'meta',
  playerSelected: 'playerSelected'
};
var _default = exports["default"] = streamEvents;
//# sourceMappingURL=streamEvents.js.map